import moment from "moment";

export const startDay = (_moment) => {
    return moment(_moment).hour(0).minute(0).second(0)
}
export const endDay = (_moment) =>{
    return moment(_moment).hour(23).minute(59).second(59)
}